import isUndefined from 'lodash.isundefined';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

// components
import EventPrices from './EventPrices';
import {
    ContainerOuterStyled,
    ContainerInnerStyled,
    ImageContainerStyled,
    ImageStyled,
    BodyContainerStyled,
} from './EventAdvertisementLayout.styled';

import { BodySmall, ButtonPrimarySmall, H4, LabelSmall } from '@styled';

// functionality
import { getCityStateDisplay } from '@general/helpers/address.helpers';
import { getDateRangeTextInEastern } from '@general/dates';
import { useScreenSmDown } from '@hooks/useResponsive';
import eventPropTypes from '@react/propTypes/eventPropTypes';

const BoostedStyled = styled.span`
    display: none;
`;

const EventAdvertisementLayout = ({ boosted, eventFromAPI, eventFromGraph, onAddClick }) => {
    const [cityState, setCityState] = useState();
    const isScreenSmDown = useScreenSmDown();

    useEffect(() => {
        if (isUndefined(eventFromAPI)) {
            return;
        }

        const city = eventFromAPI.building?.city;
        const state = eventFromAPI.building?.state_province?.code;
        setCityState(getCityStateDisplay({ city, state }));
    }, [eventFromAPI]);

    if (isUndefined(cityState) || !eventFromGraph) {
        return null;
    }

    return (
        <ContainerOuterStyled>
            <ContainerInnerStyled>
                <ImageContainerStyled>
                    <ImageStyled
                        alt={eventFromAPI.title}
                        src={
                            // eslint-disable-next-line no-nested-ternary
                            eventFromGraph?.image
                                ? eventFromGraph.image
                                : isScreenSmDown
                                ? '/assets/images/pattern-white.svg'
                                : '/assets/images/event-icon.svg'
                        }
                    />
                </ImageContainerStyled>

                <BodyContainerStyled>
                    <div className="flex-1 md:mt-0.25rem">
                        <H4>
                            {eventFromAPI.title} <BoostedStyled>({boosted || 'non-boosted'})</BoostedStyled>
                        </H4>
                        <BodySmall className="mt-0.375rem text-dark-gray">
                            {getDateRangeTextInEastern(eventFromAPI.begins_at, eventFromAPI.ends_at)}
                            {cityState.length > 0 && ` - ${cityState}`}
                        </BodySmall>
                    </div>

                    <div className="flex sm-down:justify-end sm-down:mt-1.875rem">
                        <div className="">
                            <EventPrices eventFromAPI={eventFromAPI} />
                            <LabelSmall className="block text-right">for members</LabelSmall>
                        </div>

                        <div className="ml-1.25rem">
                            <ButtonPrimarySmall onClick={() => onAddClick()}>Add</ButtonPrimarySmall>
                        </div>
                    </div>
                </BodyContainerStyled>
            </ContainerInnerStyled>
        </ContainerOuterStyled>
    );
};

EventAdvertisementLayout.propTypes = {
    boosted: PropTypes.number,
    eventFromAPI: eventPropTypes,
    eventFromGraph: PropTypes.shape({
        image: PropTypes.string,
    }),
    onAddClick: PropTypes.func.isRequired,
};

export default EventAdvertisementLayout;
